//global get/set/remove for localStorage

//get localStorage function
export const getLocalStorage = (key) => {
  if (checkIfLocalStorageWorks()) {
    return localStorage.getItem(key);
  } else {
    return null;
  }
};

//set localStorage function
export const setLocalStorage = (key, value) => {
  if (checkIfLocalStorageWorks()) {
    localStorage.setItem(key, value);
  }
};

//remove localStorage function
export const removeLocalStorage = (key) => {
  if (checkIfLocalStorageWorks()) {
    localStorage.removeItem(key);
  }
};

//check if localStorage works
export const checkIfLocalStorageWorks = () => {
  try {
    localStorage.setItem("test", "test");
    localStorage.removeItem("test");
    return true;
  } catch (e) {
    return false;
  }
};
